import { createSelector } from "@reduxjs/toolkit";

const getDeeplink = (state) => state.deeplink;

export const getDeeplinkData = createSelector(
  [getDeeplink],
  (deeplink) => deeplink?.data
);

export const getDeeplinkLoading = createSelector(
  [getDeeplink],
  (deeplink) => deeplink?.loading
);
